/** Time conversion helpers for today list reorder. */
import { DEFAULT_TASK_DURATION_MINS } from '@/config/constants';

/** @param {string | null | undefined} time */
export const timeToMinutes = (time) => {
  if (!time) return null;
  const [h, m] = String(time).split(':').map(Number);
  return h * 60 + m;
};

/** @param {number} minutes */
export const minutesToTime = (minutes) => {
  const wrapped = ((minutes % (24 * 60)) + 24 * 60) % (24 * 60);
  const hours = Math.floor(wrapped / 60)
    .toString()
    .padStart(2, '0');
  const mins = (wrapped % 60).toString().padStart(2, '0');
  return `${hours}:${mins}`;
};

/** @param {import('@/types').Task} task */
export const taskDurationMinutes = (task) =>
  typeof task?.duration === 'number'
    ? task.duration
    : DEFAULT_TASK_DURATION_MINS;

/** @param {import('@/types').Task} task */
export const endMinutesForTask = (task) =>
  timeToMinutes(task.time) + taskDurationMinutes(task);
